import { apiPgi, apiPga } from '../../../config/api'

export const requestService = {
  getRequestsListPGI: async (operationID) => {
    const { data } = await apiPgi.get(
      `pgi/getmodificationrequests/${operationID}?api-version=1.0`,
    )
    return data
  },
  getOneRequestPGI: async (id) => {
    const { data } = await apiPgi.get(
      `pgi/getmodificationrequestdetail/${id}?api-version=1.0`,
    )
    return data
  },
  getRequestsListPGA: async (operationID) => {
    const { data } = await apiPga.get(
      `pga/getmodificationrequestlist/${operationID}?api-version=1.0`,
    )
    return data
  },

  getOneRequestPGA: async (id) => {
    return await apiPga.get(
      `pga/getmodificationrequestdetail/${id}?api-version=1.0`,
    )
  },
}
